var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAwardNew = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.999C5 10.901 5.765 12.626 7 13.889V21C7 21.347 7.18 21.668 7.474 21.851C7.769 22.035 8.138 22.049 8.447 21.895L12 20.118L15.553 21.894C15.694 21.965 15.847 22 16 22C16.183 22 16.365 21.95 16.525 21.851C16.82 21.668 17 21.347 17 21V13.89C18.235 12.627 19 10.902 19 8.999C19 5.14 15.86 2 12 2C8.14 2 5 5.14 5 8.999ZM12.447 18.105C12.166 17.964 11.834 17.964 11.552 18.105L9 19.382V15.315C9.911 15.749 10.926 16 12 16C13.074 16 14.089 15.75 15 15.315V19.381L12.447 18.105ZM12 4C14.756 4 17 6.242 17 8.999C17 11.757 14.757 14 12 14C9.243 14 7 11.757 7 8.999C7 6.242 9.243 4 12 4Z",
    fill: "#3BBDED"
  })));
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAwardNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/awardNew.f6367459.svg";
export { ForwardRef as ReactComponent };